import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./ui/App";
import { ErrorBoundary } from "./ui/ErrorBoundary";
import { initializeInstallPromptCapture } from "./pwa/installPrompt";
import { initializeReleaseFreshnessChecks } from "./pwa/releaseFreshness";
import "./styles.css";

const browserGlobal = globalThis as unknown as { process?: { cwd: () => string } };
browserGlobal.process ??= { cwd: () => "/" };
initializeInstallPromptCapture();
initializeReleaseFreshnessChecks();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary><App /></ErrorBoundary>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => { void navigator.serviceWorker.register("/sw.js"); });
}
